import { CheckResult, DetailsOptical } from '@regulaforensics/vp-frontend-document-components';

export const isRecognizedDocument = (detailsOptical: DetailsOptical | undefined): boolean => {
  if (!detailsOptical) {
    return false;
  }

  return detailsOptical.docType === CheckResult.OK || detailsOptical.mrz === CheckResult.OK;
};
